module.exports = __webpack_public_path__ + "img/MES10Indice3.53f97e15.png";